import { Box, Button, Grid, InputAdornment, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Iconify from '../../../../../components/Iconify';
import SelectInput from '../../../../../components/hook-form/SelectInput';
import CustomDateRangePicker from '../../../../../components/input/CustomDatePicker';
import { fCustomDate } from '../../../../../utils/formatTime';
import { KYC_DOC_TYPE, KYC_STATUSES } from '../../../../../utils/apiUrl';
import { adminApi } from '../../../../../utils/axios';
import { resetIdentomatKycListFilters, setIdentomatKycListFilters } from '../../../../../redux/slices/filters';

const RetailKycFilter = () => {
  const currentDate = new Date();

  // Getting Date which is 30 Days back from current date
  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(currentDate.getDate() - 30);
  const [transactionStatusData, setTransactionStatusData] = useState([]);
  const [docTypeData, setDocTypeData] = useState([]);

  const { identomatListKycFilters } = useSelector((state) => state.filters);
  const dispatch = useDispatch();

  useEffect(() => {
    getTransactionStatusData();
    getDocTypeData();
  }, []);

  // Getting Status data
  const getTransactionStatusData = async () => {
    try {
      const response = await adminApi.get(KYC_STATUSES);
      setTransactionStatusData(response?.data.data.map((data) => ({ label: data.name, value: data.value })));
    } catch (error) {
      console.log(error);
    }
  };

  // Getting Doc Type data
  const getDocTypeData = async () => {
    try {
      const response = await adminApi.get(KYC_DOC_TYPE);
      // console.log('doc type', response?.data);
      setDocTypeData(response?.data?.data?.map((data) => ({ label: data.label, value: data.value })));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box sx={{ margin: '20px 24px' }}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={4} lg={2}>
          <Button
            sx={{ paddingBlock: '15px', width: '100%' }}
            variant="contained"
            endIcon={<Iconify icon={'material-symbols:filter-list-rounded'} />}
            onClick={() => dispatch(setIdentomatKycListFilters({ showFilters: !identomatListKycFilters?.showFilters }))}
          >
            Filters
          </Button>
        </Grid>
      </Grid>
      {identomatListKycFilters?.showFilters && (
        <>
          <Grid container spacing={3} sx={{ marginTop: '0px' }}>
            <Grid item xs={12} md={6} lg={6}>
              <CustomDateRangePicker
                label1="Start Date"
                label2="End Date"
                name1="from_date"
                name2="to_date"
                onChange={(e, name) =>
                  dispatch(setIdentomatKycListFilters({ [name]: e === null ? '' : fCustomDate(e) }))
                }
                val1={identomatListKycFilters?.from_date}
                val2={identomatListKycFilters?.to_date}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={6} sx={{ textAlign: 'right' }}>
              <Button
                sx={{ paddingBlock: '15px' }}
                variant="contained"
                onClick={() => dispatch(resetIdentomatKycListFilters())}
              >
                Reset Filters
              </Button>
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ marginTop: '0px' }}>
            <Grid item xs={12} md={6} lg={6}>
              <TextField
                fullWidth
                onChange={(event) => dispatch(setIdentomatKycListFilters({ search: event.target.value }))}
                placeholder="Search by ID, Name, Phone and Email"
                value={identomatListKycFilters.search}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Iconify icon={'eva:search-fill'} sx={{ color: 'text.disabled', width: 20, height: 20 }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={3}>
              <SelectInput
                label="Document Type"
                optionsRole={docTypeData}
                onChange={(event) => dispatch(setIdentomatKycListFilters({ document_type: event.target.value }))}
                value={identomatListKycFilters.document_type}
                name="document_type"
                isClear={() => dispatch(setIdentomatKycListFilters({ document_type: '' }))}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={3}>
              <SelectInput
                label="Status"
                optionsRole={transactionStatusData}
                onChange={(event) => dispatch(setIdentomatKycListFilters({ status: event.target.value }))}
                value={identomatListKycFilters.status}
                name="status"
                isClear={() => dispatch(setIdentomatKycListFilters({ status: '' }))}
              />
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  );
};

export default RetailKycFilter;
